import styled from 'styled-components';
import { useQuery } from 'react-query';
import { getMacList } from 'lib/api/device';
import { useDispatch, useSelector } from 'react-redux';
import { changeProp } from 'modules/deviceSlice';
import Loading from 'components/common/Loading';
import useLoginCheck from 'hooks/common/useLoginCheck';

const Mac = ({ mac, setShowMacBox }) => {
  const dispatch = useDispatch();

  const { device } = useSelector(({ device }) => device);

  const onSelect = () => {
    dispatch(
      changeProp({
        key: 'device',
        value: {
          ...device,
          id: mac.id,
          macAddress: mac.macAddress,
          masterId: mac.masterId,
          masterMacAddress: mac.masterMacAddress,
        },
      }),
    );
    setShowMacBox(false);
  };

  return (
    <MacBlock>
      <div onClick={onSelect}>{mac.macAddress}</div>
    </MacBlock>
  );
};

const MacBlock = styled.div`
  font-weight: 400;
  text-align: center;
  margin-bottom: 8px;
  cursor: pointer;
  &:last-child {
    margin-bottom: 0;
  }
`;

const DeviceInserModalMacBox = ({
  storeId,
  type,
  macAddress,
  setShowMacBox,
}) => {
  const { isLoading, error, data, refetch } = useQuery(
    ['macList', type, macAddress],
    () =>
      getMacList({
        storeId,
        deviceType: type,
        search: macAddress ? macAddress : '',
      }),
  );
  useLoginCheck(error?.response, refetch);
  const macList = data?.data.data;

  return (
    <DeviceInserModalMacBoxBlock>
      <div className="wrapper">
        {isLoading || error?.response.state === 401 ? (
          <Loading />
        ) : error?.response.status === 500 ? (
          <div style={{ fontSize: 12, textAlign: 'center' }}>
            서버 에러가 발생했습니다...
          </div>
        ) : macList?.length === 0 ? (
          <div
            style={{
              fontSize: 12,
              textAlign: 'center',
              fontWeight: 500,
              marginTop: 20,
            }}
          >
            목록이 없습니다
          </div>
        ) : (
          macList?.map(mac => (
            <Mac key={mac.id} mac={mac} setShowMacBox={setShowMacBox} />
          ))
        )}
      </div>
    </DeviceInserModalMacBoxBlock>
  );
};

export default DeviceInserModalMacBox;

const DeviceInserModalMacBoxBlock = styled.div`
  width: 100%;
  margin-top: 2px;
  position: absolute;

  .wrapper {
    height: 100px;
    padding: 0.5rem;
    border: solid 1px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    background: #fff;
    overflow: auto;
  }
`;
